<div class="container">
    <div class="row from-top">
        <!-- Close -->
        <button type="button" class="close-button" (click)="dialogRef.close()">&times;</button>

        <!-- Titles -->
        <div class="col-md-12 text-center mb-5">
            <i class="fa fa-info-circle fa-4x pb-4"></i>
            <h1>{{'gen_biography' | translate}}</h1>
        </div>

        <div class="col-md-3">
            <img class="img-fluid" [src]="person.avatar ? person.avatar : 'assets/images/personAvatar.png'" />
        </div>

        <div class="col-md-8">
            <h2>{{person?.name}}</h2>
            <p class="clr-sec-text">{{person?.description}}</p>
        </div>
    </div>
</div>